import { Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import { Rating } from "react-simple-star-rating";
import { FEATURES_DATA } from "../../../Data/Knowledgebase";
import { H3, Image, P } from "../../../AbstractElements";
import ProductHover from "./ProductHover";
import { FeaturedTutorial } from "../../../Constant";
import { dynamicImage } from "../../../Service/DynamicImage";

const FeaturesTutorial = () => {
  return (
    <Col lg="12">
      <div className="header-faq">
        <H3 className="mb-0">{FeaturedTutorial}</H3>
      </div>
      <Row>
        {FEATURES_DATA.map((item, id) => (
          <Col xl="3" sm="6" className="xl-50 box-col-3" key={id}>
            <Card className="features-faq product-box">
              <div className="faq-image product-img">
                <div className="knowledgebase-image">
                  <Image alt="feature" className="img-fluid" src={dynamicImage(`${item.img}`)} />
                </div>
                <ProductHover />
              </div>
              <CardBody>
                <H3>{item.title}</H3>
                <P>{item.short_description}</P>
              </CardBody>
              <CardFooter className="d-flex align-items-center justify-content-between">
                <span>{item.date}</span>
                <Rating fillColor="#ff5f24" initialValue={Math.random() * 5} size={14} />
              </CardFooter>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
export default FeaturesTutorial;
